export { colorVarNames, fontVarNames } from './theme';

export { AppShell } from './composites/AppShell';
export type { AppShellProps } from './composites/AppShell/AppShell.types';

export type { MobileTabItem } from './components/MobileTabBar/MobileTabBar.types';
export type { SideNavItem } from './components/SideNav/SideNav.types';

export { SpaListTemplate } from './templates/SpaListTemplate';
export type {
  SpaListCategoryOption,
  SpaListDurationOption,
  SpaListItem,
  SpaListTemplateProps,
} from './templates/SpaListTemplate/SpaListTemplate.types';

export { SpaCategoryListTemplate } from './templates/SpaCategoryListTemplate';
export type {
  SpaCategoryItem,
  SpaCategoryListTemplateProps,
} from './templates/SpaCategoryListTemplate/SpaCategoryListTemplate.types';

export { SpaDayDetailTemplate } from './templates/SpaDayDetailTemplate';
export type { SpaDayDetailTemplateProps } from './templates/SpaDayDetailTemplate';

export { SpaCategoryDetailTemplate } from './templates/SpaCategoryDetailTemplate';
export type { SpaCategoryDetailTemplateProps } from './templates/SpaCategoryDetailTemplate';

export type { ListItemCardProps } from './components/ListItemCard/ListItemCard.types';

export { JourneyPicker } from './composites/JourneyPicker';
export type {
  JourneyPickerCategory,
  JourneyPickerLabels,
  JourneyPickerProps,
  JourneyPickerSearchParams,
} from './composites/JourneyPicker/JourneyPicker.types';

export { Recommendations } from './composites/Recommendations';
export type { RecommendationItem, RecommendationsProps } from './composites/Recommendations';

export { ExtrasTemplate } from './templates/ExtrasTemplate';
export type {
  ExtrasGuest,
  ExtrasItem,
  ExtrasTemplateLabels,
  ExtrasTemplateProps,
} from './templates/ExtrasTemplate/ExtrasTemplate.types';

export type { ExistingGuest } from './composites/GuestDetailsPanel';

export { SpaDaysBookingForm } from './templates/SpaDaysBookingForm';
export type {
  AllOptionsConfig,
  CalendarView,
  DayAvailability,
  GuestConfig,
  OptionsPanelConfig,
  SingleOptionConfig,
  SpaDaysBookingFormLabels,
  SpaDaysBookingFormProps,
  TimeslotOption,
} from './templates/SpaDaysBookingForm/SpaDaysBookingForm.types';

export { HomeTemplate } from './templates/HomeTemplate';
export type { CategoryItem, HomeTemplateProps } from './templates/HomeTemplate/HomeTemplate.types';

export { SpaLandingTemplate } from './templates/SpaLandingTemplate';
export type {
  SpaLandingClassesBanner,
  SpaLandingSection,
  SpaLandingSectionItem,
  SpaLandingTemplateProps,
} from './templates/SpaLandingTemplate/SpaLandingTemplate.types';

export { SpaTreatmentFacilityBookingForm } from './templates/SpaTreatmentFacilityBookingForm';
export type {
  SpaGuestConfig,
  SpaTreatmentFacilityBookingFormLabels,
  SpaTreatmentFacilityBookingFormProps,
  TimeslotChip,
} from './templates/SpaTreatmentFacilityBookingForm/SpaTreatmentFacilityBookingForm.types';

export { SpaTreatmentFacilityDetailTemplate } from './templates/SpaTreatmentFacilityDetailTemplate';
export type { SpaTreatmentFacilityTemplateProps } from './templates/SpaTreatmentFacilityDetailTemplate/SpaTreatmentFacilityDetailTemplate.types';

export { SpaClassCompactCard } from './composites/SpaClassCompactCard';
export type { SpaClassCompactCardProps } from './composites/SpaClassCompactCard/SpaClassCompactCard.types';

export { ViewToggle } from './components/ViewToggle';
export type { ViewMode, ViewToggleProps } from './components/ViewToggle';

export { SpaClassListTemplate } from './templates/SpaClassListTemplate';
export type {
  SpaClassListCategoryOption,
  SpaClassListGroup,
  SpaClassListItem,
  SpaClassListTemplateProps,
} from './templates/SpaClassListTemplate/SpaClassListTemplate.types';

export { SpaClassBookingForm } from './templates/SpaClassBookingForm';
export type {
  SpaClassBookingFormLabels,
  SpaClassBookingFormProps,
  SpaClassGuestConfig,
} from './templates/SpaClassBookingForm/SpaClassBookingForm.types';

export { ConfirmationTemplate } from './templates/ConfirmationTemplate';

export type {
  ConfirmationBookingItem,
  ConfirmationTemplateLabels,
  ConfirmationTemplateProps,
  ConfirmationUpsellItem,
} from './templates/ConfirmationTemplate';

export { BasketDrawerTemplate } from './templates/BasketDrawerTemplate';
export type {
  BasketCardItem,
  BasketDrawerLabels,
  BasketDrawerTemplateProps,
  BasketDrawerView,
  ItineraryActivity,
  ItineraryDay,
  ItineraryGuest,
} from './templates/BasketDrawerTemplate';

export { BasketTemplate } from './templates/BasketTemplate';
export type {
  BasketContentsView,
  BasketTemplateLabels,
  BasketTemplateProps,
} from './templates/BasketTemplate';

export { ProductListTemplate } from './templates/ProductListTemplate';
export type {
  ProductListItem,
  ProductListTemplateProps,
} from './templates/ProductListTemplate/ProductListTemplate.types';

export { ProductDetailTemplate } from './templates/ProductDetailTemplate';

export type { GalleryImage } from './components/ImageGallery';
export type { ProductDetailTemplateProps } from './templates/ProductDetailTemplate/ProductDetailTemplate.types';

export type {
  ProductFulfilmentItem,
  ProductFulfilmentType,
  ProductOption,
} from './composites/ProductContentPanel/ProductContentPanel.types';
